export default __webpack_public_path__ + "static/media/life-icon-48px.e01628db.svg";